var render = function render(){var _vm=this,_c=_vm._self._c;return _c('filtered-search-bar',{attrs:{"namespace":_vm.projectFullPath,"tokens":_vm.tokens,"initial-filter-value":_vm.filterTokens,"search-input-placeholder":_vm.__('Search or filter results...'),"recent-searches-storage-key":"commits","show-friendly-text":"","terms-as-tokens":""},on:{"onFilter":function($event){return _vm.$emit('filter', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }